import React from 'react';
import {Table} from 'web-components';
import {useIntl} from 'react-intl';
import Util from '../../../../forecast-app/shared/util/util';
import ForecastTooltip from '../../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import {ProjectPortfolioReportTooltips} from '../ProjectPortfolioReportTooltips';
import {ForecastTooltipFormulaRenderer} from '../../../ForecastTooltipFormulaRenderer';
import {PROJECT_STATUS} from '../../../../constants';

const ProjectPortfolioMonthByMonthRow = ({rowData, tableColumnProps, headerColumn, canExpand, hasBaseline, selectedSingleValue}) => {
	const intl = useIntl();
	const {formatMessage} = intl;
	const currencySymbol = Util.GetCurrencySymbol(rowData.currency);
	const hasLowerWinChance = hasBaseline && rowData.project?.useBaseline && rowData.project?.status === PROJECT_STATUS.OPPORTUNITY && rowData.project?.baselineWinChance < 1;
	const lowerWinChanceTooltip =
		selectedSingleValue === 'forecastRevenue'
			? ProjectPortfolioReportTooltips.ForecastRevenueLowerWinChanceTooltip(formatMessage)
			: selectedSingleValue === 'forecastCost'
			? ProjectPortfolioReportTooltips.ForecastCostLowerWinChanceTooltip(formatMessage)
			: [];
	const showWinChanceTooltip = hasLowerWinChance && lowerWinChanceTooltip.length;

	const monthsData = [];
	for (const period of Object.values(rowData.aggregatedFinancialNumbers)) {
		const periodStartDate = period.split(',')[0];
		let startMonth = parseInt(periodStartDate.split('-')[1]);
		const periodEndDate = period.split(',')[1];
		const endMonth = parseInt(periodEndDate.split('-')[1]);
		while (startMonth <= endMonth) {
			const monthAmount = parseFloat(period.split(',')[2]);
			monthsData.push(monthAmount);
			startMonth += 1;
		}
	}

	const renderCurrency = (value, showZero) => {
		if (value || showZero) {
			return Util.getFormattedNumberWithCurrency(currencySymbol, value, intl);
		} else {
			return '–';
		}
	};

	if (canExpand !== undefined) {
		tableColumnProps.canExpand = canExpand;
	}

	return (
		<Table.Row {...tableColumnProps}>
			<Table.Column>{headerColumn}</Table.Column>
			{monthsData.map(monthAmount => (
				<Table.Column>
					<ForecastTooltip maxWidth="400px" content={<ForecastTooltipFormulaRenderer items={lowerWinChanceTooltip} translatedMessage={true} />} disabled={!showWinChanceTooltip}>
						{showWinChanceTooltip ? renderCurrency(monthAmount, true) + '*' : renderCurrency(monthAmount, false)}
					</ForecastTooltip>
				</Table.Column>
			))}
		</Table.Row>
	);
};

export default ProjectPortfolioMonthByMonthRow;
